import { UtilLogger } from 'common/UtilLogger';
import CommonBridge from 'common/CommonBridge';
import Constants from 'common/Constants';
import { encodeMid } from '@mi/mid-tools';

const performanceStat = (() => {
  let page = '';
  let requestTime = 0;
  let renderTime = 0;
  let url = '';
  let reqTag = '';
  return {
    initPage: (p, u) => {
      page = p;
      url = u;
    },
    freePage: () => {
      page = '';
      requestTime = 0;
      renderTime = 0;
      url = '';
      reqTag = '';
    },
    recordReqTag: (tag) => {
      if (page && !reqTag) {
        reqTag = tag;
      }
    },
    recordRequestTime: (tag, time) => {
      if (page && tag === reqTag && requestTime === 0) {
        requestTime = time;
      }
    },
    firstRenderTime: (time) => {
      renderTime = time;
      if (page && !__DEV__) {
        UtilLogger.logPerformance({
          platform: CommonBridge.isWeb() ? 'yp_rn_m' : 'rn',
          statType: 'performance',
          pageUrl: url,
          statInfo: JSON.stringify({
            reqTime: requestTime,
            renderTime: renderTime,
            pageName: page,
            type: 'rn_performance',
            stat_source: 'mstd',
            cd: Constants.UserId ? encodeMid(Constants.UserId) : '',
          }),
        });
        page = '';
      }
    },
  };
})();

export { performanceStat };
